import React, { useEffect, useState } from "react";
import authService from "../../services/AuthorizeService";
import { AuthenticationResultStatus } from "../../services/AuthorizeService";
import Constants from "../../helpers/Constants";

const Logout: React.FC<{ action: string }> = (props) => {
  const [message, setMessage] = useState("");
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    switch (props.action) {
      case Constants.LogoutActions.Logout:
        logout(getReturnUrl());
        break;
      case Constants.LogoutActions.LogoutCallback:
        processLogoutCallback();
        break;
      case Constants.LogoutActions.LoggedOut:
        setIsReady(true);
        setMessage("You successfully logged out!");
        break;
      default:
        throw new Error(`Invalid action '${props.action}'`);
    }
    setIsReady(true);
  }, [props.action]);

  const getReturnUrl = () => {
    const url = `${window.location.origin}${Constants.ApplicationPaths.LoggedOut}`;
    return url;
  };

  const navigateToReturnUrl = (returnUrl: string) => {
    return window.location.replace(returnUrl);
  };

  const processLogoutCallback = () => {
    const url = window.location.href;
    authService.completeSignOut(url).then((result) => {
      switch (result.status) {
        case AuthenticationResultStatus.Redirect:
          throw new Error("Should not redirect.");
        case AuthenticationResultStatus.Success:
          navigateToReturnUrl(getReturnUrl());
          break;
        case AuthenticationResultStatus.Fail:
          setMessage(result.message);
          break;
        default:
          throw new Error("Invalid authentication result status.");
      }
    });
  };

  const logout = (returnUrl: string) => {
    authService.isAuthenticated().then((isauthenticated) => {
      if (isauthenticated) {
        authService.signOut({ returnUrl }).then((result) => {
          switch (result.status) {
            case AuthenticationResultStatus.Redirect:
              break;
            case AuthenticationResultStatus.Success:
              navigateToReturnUrl(returnUrl);
              break;
            case AuthenticationResultStatus.Fail:
              setMessage(result.message);
              break;
            default:
              throw new Error("Invalid authentication result status.");
          }
        });
      } else {
        setMessage("You successfully logged out!");
      }
    });
  };

  if (!isReady) {
    return null;
  }
  if (!!message) {
    return <div>{message}</div>;
  } else {
    const action = props.action;
    switch (action) {
      case Constants.LogoutActions.Logout:
        return <div>Processing</div>;
      case Constants.LogoutActions.LogoutCallback:
        return <div>Processing</div>;
      case Constants.LogoutActions.LoggedOut:
        return <div>{message}</div>;
      default:
        throw new Error(`Invalid action '${action}'`);
    }
  }
};

export default Logout;
